import React, { useState, useEffect } from "react";
import { Button } from "react-bootstrap";
import { oneKlicks } from "../../../../SDK/oneclick";
import { getuserdata } from "../../../../services/apiService";
import { toast } from "react-toastify";


const ExperienceEducation = ({ educations: initialEducations, setEducations, experiences: initialExperiences, setExperiences }) => {
    const [localEducations, setLocalEducations] = useState([]);
    const [localExperiences, setLocalExperiences] = useState([]);

    useEffect(() => {
        // Initialize educations
        if (initialEducations) {
            try {
                const parsedEducations = typeof initialEducations === 'string' 
                    ? JSON.parse(initialEducations) 
                    : initialEducations;
                setLocalEducations(Array.isArray(parsedEducations) ? parsedEducations : []);
                setEducations(Array.isArray(parsedEducations) ? parsedEducations : []);
            } catch (e) {
                console.error("Error parsing educations:", e);
                setLocalEducations([]);
                setEducations([]);
            }
        }

        // Initialize experiences
        if (initialExperiences) {
            try {
                const parsedExperiences = typeof initialExperiences === 'string' 
                    ? JSON.parse(initialExperiences) 
                    : initialExperiences;
                setLocalExperiences(Array.isArray(parsedExperiences) ? parsedExperiences : []);
                setExperiences(Array.isArray(parsedExperiences) ? parsedExperiences : []);
            } catch (e) {
                console.error("Error parsing experiences:", e);
                setLocalExperiences([]);
                setExperiences([]);
            }
        }
    }, [initialEducations, initialExperiences, setEducations, setExperiences]);

    const addEducation = () => {
        const currentDate = new Date().toISOString().split('T')[0];
        const newEducation = {
            id: Date.now(),
            institute_name: '',
            degree_title: '',
            start_date: currentDate,
            ending_date: '',
            degree_description: ''
        };
        setLocalEducations([...localEducations, newEducation]);
        setEducations([...localEducations, newEducation]);
    };

    const addExperience = () => {
        const currentDate = new Date().toISOString().split('T')[0];
        const newExperience = {
            id: Date.now(),
            company_name: '',
            job_title: '',
            start_date: currentDate,
            ending_date: '',
            job_description: ''
        };
        setLocalExperiences([...localExperiences, newExperience]);
        setExperiences([...localExperiences, newExperience]);
    };

    const handleEducationChange = (index, field, value) => {
        const updatedEducations = [...localEducations];
        updatedEducations[index] = {
            ...updatedEducations[index],
            [field]: value
        };
        setLocalEducations(updatedEducations);
        setEducations(updatedEducations);
    };

    const handleExperienceChange = (index, field, value) => {
        const updatedExperiences = [...localExperiences];
        updatedExperiences[index] = {
            ...updatedExperiences[index],
            [field]: value
        };
        setLocalExperiences(updatedExperiences);
        setExperiences(updatedExperiences);
    };

    const deleteExperience = async (id) => {
        try {
            const user_id = localStorage.getItem("doctorId") || await getuserdata("id");
            console.log('user_id', user_id);
            const filteredExperiences = localExperiences.filter(exp => exp.id !== id);
            const tableSchema = "";
            const tableName = "doctor_experience_education";
            const data = {
                experiences: JSON.stringify(filteredExperiences)
            };
            const condition = {
                user_id: user_id
            };
            const deleteExperience = await oneKlicks.update(tableSchema, tableName, data, condition);
            console.log('deleteExperience :', deleteExperience);
            if (deleteExperience.success === true) {
                toast.success("Experience deleted successfully");
            }else{
                console.log('deleteExperience :', deleteExperience);
                toast.error("Experience deleted failed");
            }
        } catch (error) {
            console.log(error);
            toast.error("Experience deleted failed");
        }
    };

    const deleteEducation = async (id) => {
        try {
            console.log('id :', id);
            const user_id = localStorage.getItem("doctorId") || await getuserdata("id");
            console.log('user_id :', user_id);
            console.log('localEducations :', localEducations);
            const filteredEducations = localEducations.filter(exp => exp.id !== id);
            console.log('filteredEducations :', filteredEducations);
            const tableSchema = "";
            const tableName = "doctor_experience_education";
            const data = {
                educations: JSON.stringify(filteredEducations)
            };
            const condition = {
                user_id: user_id
            };
            const deleteExperience = await oneKlicks.update(tableSchema, tableName, data, condition);
            console.log('deleteExperience :', deleteExperience);
            if (deleteExperience.success === true) {
                toast.success("Experience deleted successfully");
            }else{
                toast.error("Experience deleted failed");
            }
        } catch (error) {
            console.log(error);
            toast.error("Experience deleted failed");
        }
    };

    const formatDate = (dateString) => {
        if (!dateString) return '';
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' });
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-personalskillshold tab-pane active fade show" id="dc-skills">
                <div className="dc-usereducation dc-tabsinfo">
                    <div className="dc-tabscontenttitle dc-addnew">
                        <h3>Add Your Education</h3>
                        <Button className="dc-btn dc-btnactive new" onClick={addEducation} style={{float: 'right'}}>
                            {window.innerWidth < 576 ? <i className="lnr lnr-plus-circle"></i> : 'Add New'}
                        </Button>
                    </div>
                    <ul className="dc-educationaccordion accordion dc-educations">
                        {Array.isArray(localEducations) && localEducations.map((education, index) => (
                            <li key={education.id}>
                                <div className="dc-accordioninnertitle">
                                    <span id={`accordioninnertitle${index}`} data-toggle="collapse" data-target={`#innertitle${index}`}>
                                        {education.degree_title || 'Education title'}
                                    </span>
                                    <em>({formatDate(education.start_date)} - {education.ending_date ? formatDate(education.ending_date) : 'Present'})</em>
                                    <div className="dc-rightarea">
                                        <a className="dc-addinfo dc-skillsaddinfo" id={`accordioninnertitle${index}`} data-toggle="collapse" data-target={`#innertitle${index}`} aria-expanded="true">
                                            <i className="lnr lnr-pencil"></i>
                                        </a>
                                        <a className="dc-deleteinfo" key={education.id} onClick={() => deleteEducation(education.id)}>
                                            <i className="lnr lnr-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="dc-collapseexp collapse show" id={`innertitle${index}`} aria-labelledby={`accordioninnertitle${index}`} data-parent="#accordion">
                                    <div className="dc-formtheme dc-userform">
                                        <fieldset>
                                            <div className="form-group form-group-half">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Institute name" 
                                                    value={education.institute_name || ''}
                                                    onChange={(e) => handleEducationChange(index, 'institute_name', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group form-group-half">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Degree title" 
                                                    value={education.degree_title || ''}
                                                    onChange={(e) => handleEducationChange(index, 'degree_title', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group form-group-half">
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    placeholder="Starting Date" 
                                                    value={education.start_date || ''}
                                                    onChange={(e) => handleEducationChange(index, 'start_date', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group form-group-half">
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    placeholder="Ending Date" 
                                                    value={education.ending_date || ''}
                                                    onChange={(e) => handleEducationChange(index, 'ending_date', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <textarea 
                                                    className="form-control" 
                                                    placeholder="Your Education Description" 
                                                    value={education.degree_description || ''}
                                                    onChange={(e) => handleEducationChange(index, 'degree_description', e.target.value)}
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <span>* Leave ending date empty if it's your current education</span>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="dc-userexperience dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle dc-addnew">
                        <h3>Add Your experience</h3>
                        <Button className="dc-btn dc-btnactive new" onClick={addExperience} style={{float: 'right'}}>
                            {window.innerWidth < 576 ? <i className="lnr lnr-plus-circle"></i> : 'Add New'}
                        </Button>
                    </div>
                    <ul className="dc-experienceaccordion accordion dc-experiences">
                        {Array.isArray(localExperiences) && localExperiences.map((experience, index) => (
                            <li key={experience.id}>
                                <div className="dc-accordioninnertitle">
                                    <span id={`accordioninnertitle${index}`} data-toggle="collapse" data-target={`#innertitle${index}`}>
                                        {experience.job_title || 'Company title'}
                                    </span>
                                    <em>({formatDate(experience.start_date)} - {experience.ending_date ? formatDate(experience.ending_date) : 'Present'})</em>
                                    <div className="dc-rightarea">
                                        <a className="dc-addinfo dc-skillsaddinfo" id={`accordioninnertitle${index}`} data-toggle="collapse" data-target={`#innertitle${index}`} aria-expanded="true">
                                            <i className="lnr lnr-pencil"></i>
                                        </a>
                                        <a className="dc-deleteinfo" key={experience.id} onClick={() => deleteExperience(experience.id)}>
                                            <i className="lnr lnr-trash"></i>
                                        </a>
                                    </div>
                                </div>
                                <div className="dc-collapseexp collapse show" id={`innertitle${index}`} aria-labelledby={`accordioninnertitle${index}`} data-parent="#accordion">
                                    <div className="dc-formtheme dc-userform">
                                        <fieldset>
                                            <div className="form-group form-group-half">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Company name" 
                                                    value={experience.company_name || ''}
                                                    onChange={(e) => handleExperienceChange(index, 'company_name', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group form-group-half">
                                                <input 
                                                    type="text" 
                                                    className="form-control" 
                                                    placeholder="Job title" 
                                                    value={experience.job_title || ''}
                                                    onChange={(e) => handleExperienceChange(index, 'job_title', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group form-group-half">
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    placeholder="Starting Date" 
                                                    value={experience.start_date || ''}
                                                    onChange={(e) => handleExperienceChange(index, 'start_date', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group form-group-half">
                                                <input 
                                                    type="date" 
                                                    className="form-control" 
                                                    placeholder="Ending Date" 
                                                    value={experience.ending_date || ''}
                                                    onChange={(e) => handleExperienceChange(index, 'ending_date', e.target.value)}
                                                />
                                            </div>
                                            <div className="form-group">
                                                <textarea 
                                                    className="form-control" 
                                                    placeholder="Your Job Description" 
                                                    value={experience.job_description || ''}
                                                    onChange={(e) => handleExperienceChange(index, 'job_description', e.target.value)}
                                                ></textarea>
                                            </div>
                                            <div className="form-group">
                                                <span>* Leave ending date empty if it's your current job</span>
                                            </div>
                                        </fieldset>
                                    </div>
                                </div>
                            </li>
                        ))}
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default ExperienceEducation;
